import { IconLoader2 } from '@tabler/icons-react';
import styles from './ChartCardLoading.module.css';

export const ChartCardLoading = () => <IconLoader2 className={styles.loading} />;
